import { render, staticRenderFns } from "./VisaReport.vue?vue&type=template&id=1bb44466"
import script from "./VisaReport.vue?vue&type=script&lang=js"
export * from "./VisaReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports